const VUE_APP_API_HERA_URL = document.querySelector("html").getAttribute("api_hera_url");

export default VUE_APP_API_HERA_URL


// WEBPACK FOOTER //
// ./src/util/getapi/hera.js